import React, { PureComponent } from 'react'
import autobind from 'autobind-decorator'
import styles from './styles'

import Alert from '../Alert'
import Button from '../Button'
import BackButton from '../BackButton'
import Controller from '../FormsController'

export default class Panel extends PureComponent {
  state = { valid: false, intial: true }

  componentDidMount() {
    let answer = Controller[this.props.title].answer
    this.refs.input.value = answer
  }

  @autobind onChange() {
    const answer = this.refs.input.value
    const { title, question } = this.props
    Controller.update(title, { question, answer })
  }

  get valid() {
    if (!this.state.valid && !this.state.intial) {
      return (<Alert message='Answer can not be empty' />)
    }
  }

  @autobind next() {
    this.props.change(this.props.nextQuestion)
  }

  @autobind goBack() {
    this.props.goBack()
  }

  @autobind goToNext(event) {
    if (event.key === 'Enter') {
      this.next()
    }
  }

  render() {
    const { question, buttonText } = this.props
    return (
      <div className={styles.wrapper}>
        <div className={styles.question}>
          <p> {question} </p>
        </div>
        <div>
          <textarea spellCheck='true' type='text' ref='input' onChange={this.onChange} onKeyDown={this.goToNext} className={styles.textarea} autoFocus placeholder='Type Anwser Here' />
        </div>
        {this.valid}}
        <div className={styles.buttonDiv}>
          <div className={styles.buttonBack}>
            <BackButton onClick={this.goBack} />
          </div>
          <div className={styles.buttonNext}>
            <Button onClick={this.next}>
              {buttonText}
              <svg width='25' height='25' viewBox='0 0 24 24'>
                <path d='M5 3l3.057-3 11.943 12-11.943 12-3.057-3 9-9z' />
              </svg>
            </Button>
          </div>
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ../app/Components/Survey/Panel/Panel.js
 **/